import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
// import loadable from '@loadable/component';

import { Title } from '@vds/typography';
import { ListGroup, ListGroupItem, ListGroupItemSubtitle, ListGroupItemTitle } from '@vds/lists';
import { useHistory } from 'react-router-dom';
import { selectStateCache } from '../@selectors';
import { useCheckoutHooks } from '../@Redux/checkout.hooks';
import ContactInfo from './ContactInfo';
import { Margin } from '../../../common/styles';
import { checkoutLabels } from '../Components/labels';
import { isMobile } from '../../../common/Helpers';
import ShippingSection from './ShippingSection';
import { goToProcessStep } from '../../../../redirection';
import { getPaymentDetails } from '../Helper/payloadHelper';

// import { DeviceContainer, TilesContainer } from '../../../common/Cart/Tiles.styles';

const CheckoutInfo = () => {
  const stateCache = useSelector((state) => selectStateCache(state), shallowEqual);
  const { payments, currentView, isPaymentNeeded, isPaymentDetailsAvailable, SetUp } = useCheckoutHooks(stateCache);
  const history = useHistory();

  const editRedirect = (pageName) => {
    let updateView = '';
    if (pageName === 'Payment') {
      history.push('payment.html');
      updateView = currentView.Payment;
    } else if (pageName === 'Shipping') {
      history.push('shipping.html');
      updateView = currentView.Shipping;
    }
    goToProcessStep(updateView, history);
  };

  return (
    <div style={isMobile() ? { marginLeft: '10px', marginRight: '10px' } : { marginLeft: '5px', marginRight: '5px' }}>
      <Margin top="40px" bottom={isMobile() ? '' : '40px'}>
        <Title size="medium" bold>
          {checkoutLabels.checkoutHeading}
        </Title>
      </Margin>
      <Margin padding="24px" width="100%" />
      <ContactInfo />
      {SetUp.indexOf('Self') > -1 && <ShippingSection redirect={editRedirect} />}
      {isPaymentNeeded && isPaymentDetailsAvailable ? (
        <ListGroup topLine={false} bottomLine surface="light" viewport="desktop">
          <ListGroupItem
            data-track='{"type":"link","name":"payment method|express checkout","data":{"page":{"throttle":"nsa version|vhi|ec y"},"target":{"sandBox":"FWA_Express_T_Checkout"}}}'
            textHierarchy="subtitleProminent"
            actionElement="icon"
            icon={{ onClick: () => editRedirect('Payment') }}
          >
            <ListGroupItemTitle bold={false}>{getPaymentDetails(payments)}</ListGroupItemTitle>
            <ListGroupItemSubtitle>{checkoutLabels.expressPaymentHeader}</ListGroupItemSubtitle>
          </ListGroupItem>
        </ListGroup>
      ) : null}
    </div>
  );
};
export default CheckoutInfo;
